import type { HTMLAttributes } from 'react'
import React from 'react'
import { csx, cx } from '@vtex/admin-ui'

export type ShelfWithoutDataContainerProps = HTMLAttributes<HTMLDivElement>

export const ShelfWithoutDataContainer = ({
  children,
  className = '',
  ...props
}: ShelfWithoutDataContainerProps) => (
  <div
    {...props}
    className={cx(
      csx({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: '$secondary',
        paddingY: '$space-28',
        position: 'relative',
        height: '100%',
      }),
      className
    )}
  >
    {children}
  </div>
)
